if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }


//////////////////
// WEBPACK FOOTER
// ./src/infrastructure/polyfills/StartsWith.js
// module id = 1322
// module chunks = 0